import React from 'react';
import {
    Button, Dialog, Grid, Icon, Typography
} from '@material-ui/core';

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { formatDate } from '../../../../components/Common/Extensions';
import SendQRIcon from '../../../../assets/img/icons/SimActivationIcon.svg';
import PreviewIcon from '../../../../assets/img/icons/eye.svg';
import useStyles from "./styles";
import Tooltip from '@material-ui/core/Tooltip';

function BeneficiariesDialog({
    dialogOpenClose,
    handleClose,
    record,
    beneficiariesData,
    onActionClick
}) {
    const classes = useStyles();

    const closeDialog = () => {
        handleClose();
    };

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
        >
            <div className={classes.dialogContent}>

                <div className={classes.box}>

                    {/* HEADER */}
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>
                            {'Beneficiaries Detail - (' + record?.formatedApplicationId + ')'}
                        </Typography>

                        <Icon className={classes.closeIcon} onClick={closeDialog} color="primary">
                            <CloseIcon />
                        </Icon>
                    </div>

                    {/* CONTENT */}
                    <Scrollbars autoHeight autoHeightMax={480}>
                        <div className={classes.content}>

                            <Grid container spacing={2} style={{ padding: '20px' }}>

                                <table className={classes.activationTable}>
                                    <thead>
                                        <tr className={'headerRow'}>
                                            <th>Full Name</th>
                                            <th>DOB</th>
                                            <th>School</th>
                                            <th>IMEI #</th>
                                            <th>SIM Card #</th>
                                            <th>Assigned Phone #</th>
                                            <th className="textCenter">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            beneficiariesData
                                                ?.filter(b => !b.isDeleted)
                                                ?.map((child) => {

                                                    const getSafeValue = (val) => {
                                                        return (val === null || val === "null" || val === "undefined" || val === undefined)
                                                            ? ''
                                                            : val;
                                                    };

                                                    return (
                                                        <tr key={child.beneficiaryId}>

                                                            <td>
                                                                {child.firstName} {child.lastName}
                                                            </td>

                                                            <td>
                                                                {child.dateOfBirth ? formatDate(child.dateOfBirth) : ''}
                                                            </td>

                                                            <td>
                                                                {getSafeValue(child.school)}
                                                            </td>

                                                            <td>
                                                                {getSafeValue(child.deviceIdentification)}
                                                            </td>

                                                            <td>
                                                                {getSafeValue(child.icc)}
                                                            </td>

                                                            <td>
                                                                {getSafeValue(child.assignedPhoneNumber)}
                                                            </td>

                                                            <td className="textCenter">

                                                                <Tooltip title="Preview" placement="top">
                                                                    <img
                                                                        src={PreviewIcon}
                                                                        alt="preview"
                                                                        style={{ cursor: 'pointer', marginRight: '10px', width: 18 }}
                                                                        onClick={() => onActionClick('preview', child)}
                                                                    />
                                                                </Tooltip>

                                                                <Tooltip title="Send QR Code" placement="top">
                                                                    <img
                                                                        src={SendQRIcon}
                                                                        alt="send qr"
                                                                        style={{ cursor: 'pointer', width: 18 }}
                                                                        onClick={() => onActionClick('sendQR', child)}
                                                                    />
                                                                </Tooltip>

                                                            </td>

                                                        </tr>
                                                    );
                                                })
                                        }
                                    </tbody>
                                </table>

                            </Grid>

                        </div>
                    </Scrollbars>

                    {/* FOOTER */}
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={closeDialog}>
                                Close
                            </Button>
                        </div>
                    </div>

                </div>
            </div>

        </Dialog>
    );
}

export default BeneficiariesDialog;